import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchSkills } from "../../../../actions/skills.actions";
import Skills from "../components/Skills";
import { updateUserData } from "../../../../actions/user.actions";

class SkillsContainer extends Component {
  constructor(props) {
    super(props);
    this.memberId = this.props.match.params.memberId;
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.fetchSkills();
  }

  handleSubmit(data) {
    const filteredSkills = [];

    if (data.skills) {
      data.skills.forEach((isSkillSelected, index) => {
        if (isSkillSelected) {
          filteredSkills[index] = isSkillSelected;
        }
      });
    }

    data.skills = filteredSkills;
    if (!this.memberId) {
      this.props.updateUserData(data, "/member/profile", "skills");
    } else {
      const url = /(5|6|7|9)/.test(this.props.user.status_id)
        ? `/admin/member/${this.memberId}/moderation`
        : `/admin/member/approved/${this.memberId}/profile`;

      this.props.updateUserData(data, url, "skills");
    }
  }

  render() {
    return (
      <Skills
        onSubmit={this.handleSubmit}
        skills={this.props.skills}
        memberId={this.memberId}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    skills: state.skills.skills.data,
    user: state.user.data
  };
};

const mapDispatchToProps = dispatch => ({
  fetchSkills: () => dispatch(fetchSkills()),
  updateUserData: (user, redirect, formName) =>
    dispatch(updateUserData(user, redirect, formName))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SkillsContainer);



// WEBPACK FOOTER //
// ./src/routes/candidate/profile/containers/SkillsContainer.js